// @ts-nocheck
import Petition from "../../../modules/petition";
import * as FormData from 'form-data';

// /**
//  * Use Petition
//  * 
//  * You must use pet.get(url) or pet.post(url, data) 
//  */

const pet = new Petition()

export class triviaService {
    getDataTrivia() {
        return pet.post('/150porciento/trivia/get', {})
    }
    getSummary() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    points: 250,
                    correctAnswers: 2,
                    time: 6574
                })
                return
            }, 0)
        })
    }
    getSummary2() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({})
            }, 0)
        })
    }
    sendTriviaResponse(data: any) {
        let formData = new FormData();
        for (const key in data) {
            formData.append(key, data[key])
        }
        return pet.postFD('/user/trivia/check', formData)
    }
    triviaIsDone() {
        let setPrefix = {'prefix': window.prefix}
        return pet.post('/150porciento/trivia/check', {setPrefix})
    }
    welcome() {
        return 'welcome to ApiService';
    }
    example() {
        return pet.get('http://api.150porciento.com/api/countries')
    }
    getRankingData() {
        return pet.get('/user/trivia/ranking')
     }
}